import { render, staticRenderFns } from "./despatch-order-v1.vue?vue&type=template&id=2301effd&"
import script from "./despatch-order-v1.vue?vue&type=script&lang=js&"
export * from "./despatch-order-v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports